import ModalTabuYashirRequestDone from './ModalTabuYashirRequestDone';

export default ModalTabuYashirRequestDone;
